export enum AppNotificationTypeEnum {
  success = 'success',
  error = 'error'
}
